import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useDisconnectSlack(tenant: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axios.delete(`${getBongoUrl()}/v1/org/${tenant}/integrations/slack`);
    },
    onSuccess: () => {
      queryClient.setQueryData(['slack', tenant], false);
      queryClient.setQueryData(['slack-subscriptions', tenant], []);
      queryClient.setQueryData(['slack-channels', tenant], []);
    },
  });
}
